const configs = {
    mobileBreakpoint: 580,
}

export default configs;